export const INITIAL_QUESTION_PAYLOAD = [
  {
    question: 'Have you or your business been declared insolvent within the past five years?',
    answer: 'N',
    consent: 'Y',
    timestamp: ''
  },
  {
    question:
      'Have you or your business had a county court judgement or decree ' +
      'for more than £250 within the past six years?',
    answer: 'N',
    consent: 'Y',
    timestamp: ''
  },
  {
    question:
      'Have you ever been disqualified as a company director or member of a limited liability partnership?',
    answer: 'N',
    consent: 'Y',
    timestamp: ''
  },
  {
    question: 'Will your business handle clients money through this account?',
    answer: 'N',
    consent: 'Y',
    timestamp: ''
  },
  {
    question:
      'Is your business registered (or planning to register) as a payment service provider?',
    answer: 'N',
    consent: 'Y',
    timestamp: ''
  }
];
